"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionBillingFrequency = void 0;
var SubscriptionBillingFrequency;
(function (SubscriptionBillingFrequency) {
    SubscriptionBillingFrequency["YEARLY"] = "yearly";
    SubscriptionBillingFrequency["MONTHLY"] = "monthly";
    SubscriptionBillingFrequency["WEEKLY"] = "weekly";
    SubscriptionBillingFrequency["DAILY"] = "daily";
    SubscriptionBillingFrequency["LIFETIME"] = "lifetime";
    SubscriptionBillingFrequency["SIX_MONTH"] = "six_month";
    SubscriptionBillingFrequency["THREE_MONTH"] = "three_month";
    SubscriptionBillingFrequency["THREE_DAY"] = "three_day";
})(SubscriptionBillingFrequency || (exports.SubscriptionBillingFrequency = SubscriptionBillingFrequency = {}));
